import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { ReferencePatentsImpl } from './services/impls/reference-patents';
import { ReferencePatents } from './services/reference-patents';
import { ReferencePatentModelImpl } from './models/impls/reference-patent-model';
import { ReferencePatentModel } from './models/reference-patent-model';
import { PatentProfileRepositoryImpl } from './repositories/impls/patent-profile-repository';
import { PatentProfileRepository } from './services/patent-profile-repository';

export const referencePatentsModule = (bind: interfaces.Bind) => {
    bind(ReferencePatents).to(ReferencePatentsImpl);
    bind(ReferencePatentModel).to(ReferencePatentModelImpl);
    bind(PatentProfileRepository).to(PatentProfileRepositoryImpl);
};
